import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map'
import { Source } from '../models/Source';
import { Test } from '../models/Test';
import { Site } from '../models/Site';
import { PlatformLocation } from '@angular/common';

@Injectable()
export class SourceService {

  constructor(
    private http: HttpClient, private location: PlatformLocation ) { }

  //getSources() {
  //  let headers = new HttpHeaders();
  //  headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
  //  headers = headers.append("Content-Type", "application/json");

  //  return this.http.get<Source[]>(this.location.getBaseHrefFromDOM() +'api/sources', { headers: headers });
  //}

  filterSources(siteId: number, filter: string) {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");
    return this.http.get<Source[]>(this.location.getBaseHrefFromDOM() +'api/sources/'+ siteId + '/' + filter, { headers: headers });
  }

  getTop10Tests(siteId, sourceId) {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");
    return this.http.get<Test[]>(this.location.getBaseHrefFromDOM() + `api/toptests/${siteId}/${sourceId}`, { headers: headers });
  }

  getSites() {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");
    return this.http.get<Site[]>(this.location.getBaseHrefFromDOM() + 'api/sites', { headers: headers });
  }

}
